
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1mabk_rj2cy_5",
  "radio": "awsui_radio_1mabk_rj2cy_16",
  "radio--has-description": "awsui_radio--has-description_1mabk_rj2cy_24",
  "radio-control": "awsui_radio-control_1mabk_rj2cy_28",
  "input": "awsui_input_1mabk_rj2cy_36",
  "styled-circle-border": "awsui_styled-circle-border_1mabk_rj2cy_58",
  "styled-circle-disabled": "awsui_styled-circle-disabled_1mabk_rj2cy_62",
  "styled-circle-fill": "awsui_styled-circle-fill_1mabk_rj2cy_67",
  "styled-circle-checked": "awsui_styled-circle-checked_1mabk_rj2cy_73"
};
  